import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=585f6b82&scoped=true"
import script from "./leave.vue?vue&type=script&lang=js"
export * from "./leave.vue?vue&type=script&lang=js"
import style0 from "./leave.vue?vue&type=style&index=0&id=585f6b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f6b82",
  null
  
)

export default component.exports